import { apiGet, API_URI } from 'api';

const Blogs = {
    getAll : async () => {
        const data = await apiGet(`${API_URI}/api/blog`);
        return data;
    }
}

export default Blogs;